<div ngbDropdown  *ngIf="dropout"  placement="bottom-start" class="ltms-ngb-dropdown" #myDrop="ngbDropdown">
  <button type="button" class="ltms-dropdown-button" [class.open]="myDrop.isOpen()" ngbDropdownToggle>
    <div class="button-text" *ngIf="selectedOption && selectedOption.name" [title]="preffix + ' ' + selectedOption.name">
      {{preffix}} {{ selectedOption.name }}
    </div>
    <div class="button-text" *ngIf="!(selectedOption && selectedOption.name)">{{placeholder||'Select one'}}{{myDrop.isOpen}}</div>
    <div class="icon-wrapper" [class.open]="myDrop.isOpen()">
      <img src="assets/images/menu-down-dark.svg" />
    </div>
   
  </button>
  <div ngbDropdownMenu *ngIf="categorization" class="ltms-ngb-dropdown-categorized-list {{className}}">
    <div *ngFor="let category of list" class="categorized-list">
      <div class="dropdown-category">
        <div class="category-title">{{preffix}} {{category.category_name}}</div>
      </div>
      <button *ngFor="let option of category.child_options" [class.active]="option.field_id === selectedOption.field_id" (click)="selectOption(option); $event.stopPropagation()"
        ngbDropdownItem><div class="wrapper">{{preffix}} {{option.name}}</div></button>
    </div>
  </div>
  <div ngbDropdownMenu *ngIf="!categorization" class="ltms-ngb-dropdown-list">
    <button ngbDropdownItem *ngFor="let option of list"
      (click)="selectOption(option); $event.stopPropagation()">
      <div class="wrapper">{{preffix}} {{option.name}}</div>
    </button>
  </div>
</div>
<div class="ltms-dropdown" *ngIf="!dropout" #ltmsdropdown id="ltms-dropdown">
  <button [ngStyle]="{width: config.width}" class="ltms-dropdown-button" id="ltms-dropdown-button-{{timestamp}}" (click)="toggleDropdown($event); $event.stopPropagation()">
    <div class="button-text" *ngIf="selectedOption && selectedOption.name && !selectedOption.component_id">{{preffix}} {{ selectedOption.name }}</div>
    <div class="button-text" *ngIf="selectedOption && selectedOption.name && selectedOption.component_id == 'quick-insight'">{{selectedOption.preffix}} {{ selectedOption.name }}</div>
    <div class="button-text"  *ngIf="!(selectedOption && selectedOption.name)">{{placeholder||'Select one'}}</div>
    <img src="assets/images/menu-down-dark.svg" [class.open]="isOpen"/>
  </button>
  <ul [class.show]="isOpen" *ngIf="categorization" id="ltms-dropdown-categorized-menu-{{timestamp}}"  class="ltms-dropdown-categorized-list">
    <li *ngFor="let category of list">
      <div class="dropdown-category" *ngIf="!config.component_id">
        <div class="category-title">{{preffix}} {{category.category_name}}</div>
      </div>
      <div class="dropdown-category quick-insight-category" *ngIf="config.component_id == 'quick-insight'">
        <div class="category-title" >{{category.category_name}}</div>
      </div>
      <ul class="ltms-dropdown-sub-list">
        <li *ngFor="let option of category.child_options" (click)="selectOption(option); $event.stopPropagation()"
          [class.active]="option.field_id === selectedOption.field_id">
          <div class="wrapper" *ngIf="!option.component_id">{{preffix}} {{option.name}}</div>
          <div class="wrapper" *ngIf="option.component_id == 'quick-insight'">{{option.preffix}} {{option.name}}</div>
        </li>
      </ul>
    </li>
  </ul>
  <ul [class.show]="isOpen" *ngIf="!categorization" id="ltms-dropdown-default-menu-{{timestamp}}" class="ltms-dropdown-list">
    <li *ngFor="let option of list" (click)="selectOption(option); $event.stopPropagation()"
      [class.active]="option[comparisionField] === selectedOption[comparisionField]">
      <div class="wrapper">{{preffix}} {{option.name}}</div>
    </li>
  </ul>
</div>